<template>
  <div>
    <slot :loading="loadingFollowStatus" :follow="follow">
    </slot>
  </div>
</template>

<script>
import LogRocket from "logrocket";
import call from "@/api/calls";

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  name: "followAction",
  model: {
    prop: 'status',
    event: 'changeStatus'
  },
  props: {
    status: {
      type: Boolean,
      default: () => undefined
    }
  },
  data() {
    return {
      loadingFollowStatus: false,
      user: JSON.parse(localStorage.getItem('user'))
    }
  },
  mounted() {
    this.$on('click', () => this.follow());
  },
  methods: {
    follow(profile) {
      if (typeof this.status != "boolean")
        return;

      this.loadingFollowStatus = true;

      (!this.status
      ? call.friend.follow(profile, this.user.id)
        .then(() => {
          this.$emit('changeStatus', true);
          this.loadingFollowStatus = false;
        })
      : call.friend.unfollow(profile, this.user.id)
        .then(() => {
          this.$emit('changeStatus', false);
          this.loadingFollowStatus = false;
        })
      ).catch(error => {
        this.loadingFollowStatus = false;
        this.error = error;
        log(error, "follow(profile)", { profile, user: this.user.id });
        alert("Erro! Tente novamente.");
      })
    }
  },
}
</script>
